import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import iconGo from '@/images/icon-go.svg'
import iconPerson from '@/images/icon-person.svg'

const StLink = styled(Link)`
  position: relative;
  line-height: 1;
  display: block;
  padding: 0.5rem 0;
  margin-left: 32px;
  .svg-wrap {
    position: absolute;
    left: -21px;
    top: 7px;
    svg {
      vertical-align: middle !important;
    }
  }

  &:after {
    content: '';
    background: url(${iconGo}) no-repeat center center;
    display: inline-block;
    height: 0.7em;
    width: 1em;
  }
`

const VotacionPerson = ({ children, to }) => {
  return (
    <StLink className="text-xl " to={to}>
      {children}
    </StLink>
  )
}

export default VotacionPerson
